import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from '../../../components';


const EmptyBooking = () => {
  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.app);

  const handleSellClick = () => {
   navigate('/all-events', { state: 'primary' });
  };
  return (
    <div className='flex gap-20 border rounded-xl border-grey-10  w-auto md:w-[630px]'>
      <div className='flex flex-col gap-6 pl-9 py-8'> 
        <div className='flex flex-col gap-3'> 
          <div className='heading-16'>No tickets purchased yet!</div>
          <div className='text-14'>Your purchased tickets would appear here.</div>
        </div>
        <Button
          type='primary'
          onClick={handleSellClick}>Explore events</Button>
      </div>
      <img
        src='assets/images/nolist.png'
        alt='no list'
        className='rounded-r-lg md:block hidden'
      />
      
    </div>
  )
}

export default EmptyBooking;